var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInactivityDetected = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 38 38"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#InactivityDetected_svg__a)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 18,
  r: 15.273,
  fill: "#AAA",
  stroke: "#fff",
  strokeWidth: 1.455
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m27.441 17.247 1.84-1.84c-3.43-3.43-8.157-4.735-12.598-3.963l2.372 2.373a11.72 11.72 0 0 1 8.386 3.43m-1.839 1.839a9.1 9.1 0 0 0-3.42-2.143l2.777 2.777zm-9.195 3.678 2.759 2.759 2.758-2.76a3.896 3.896 0 0 0-5.517 0M11.267 8.64 9.97 9.936l2.805 2.805a14.4 14.4 0 0 0-3.724 2.667l1.839 1.839a11.6 11.6 0 0 1 3.834-2.557l2.06 2.06a9.03 9.03 0 0 0-4.055 2.336l1.839 1.839a6.44 6.44 0 0 1 4.496-1.894l6.51 6.51 1.297-1.297z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "InactivityDetected_svg__a",
  width: 38,
  height: 38,
  x: 0,
  y: 0,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_712_2001"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect1_dropShadow_712_2001",
  result: "effect2_dropShadow_712_2001"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  radius: 1,
  result: "effect3_dropShadow_712_2001"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect2_dropShadow_712_2001",
  result: "effect3_dropShadow_712_2001"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect3_dropShadow_712_2001",
  result: "shape"
})))));
export { SvgInactivityDetected as ReactComponent };
export default __webpack_public_path__ + "static/media/InactivityDetected.16b4f72d.svg";